import { useAchievementTypes, useReduxState } from 'hooks';
import { ApiDownloadButton, MoreOptions } from 'components/common';
import { UsersSendMessage } from 'components/users';
import {
  AchievementCompletionsAdd,
  AchievementCompletionsRemoveAll,
  AchievementGroupOfUsersAdd,
  AchievementGroupOfUsersRemove
} from '.';

interface Props {
  alreadyAddedUsersByEmail: { [key: string]: boolean };
  alreadyAddedUsersByUsername: { [key: string]: boolean };
  listOfGroupCompletionIds: number[];
  listOfUserIds: number[];
  updateUsers: () => Promise<void>;
  usersWithInProgressAchievementByEmail: { [key: string]: boolean };
  usersWithInProgressAchievementByUsername: { [key: string]: boolean };
}

const AchievementUsersHeader = ({
  alreadyAddedUsersByEmail,
  alreadyAddedUsersByUsername,
  listOfGroupCompletionIds,
  listOfUserIds,
  updateUsers,
  usersWithInProgressAchievementByEmail,
  usersWithInProgressAchievementByUsername
}: Props) => {
  const {
    messages,
    pageState: { achievement },
    serverConfig: { adminUrl }
  } = useReduxState();

  const { isGroupAchievement } = useAchievementTypes({
    type: achievement?.type
  });

  if (
    !achievement.isOwnerOrSuperadmin &&
    !achievement.userAdminPermissions.includes('manage-users')
  ) {
    return null;
  }

  return (
    <div style={{ alignItems: 'center', display: 'flex', gap: 10 }}>
      <UsersSendMessage
        buttonSize="header"
        emailButtonTarget={`${adminUrl}/achievements/${achievement.id}`}
        id="achievement-users-header-send-message"
        userSelectionParams={{
          excludeUsersWithoutEmail: true,
          selectedUserIds: listOfUserIds || [],
          userSelector: 'emails'
        }}
      />

      {isGroupAchievement ? (
        <AchievementGroupOfUsersAdd updateGroups={updateUsers} />
      ) : (
        <AchievementCompletionsAdd
          alreadyAddedUsersByEmail={alreadyAddedUsersByEmail}
          alreadyAddedUsersByUsername={alreadyAddedUsersByUsername}
          updateUsers={updateUsers}
          userIds={listOfUserIds}
          usersWithInProgressAchievementByEmail={
            usersWithInProgressAchievementByEmail
          }
          usersWithInProgressAchievementByUsername={
            usersWithInProgressAchievementByUsername
          }
        />
      )}

      <MoreOptions category="lighter">
        <ApiDownloadButton
          category="success"
          disabled={
            isGroupAchievement
              ? !listOfGroupCompletionIds?.length
              : !listOfUserIds?.length
          }
          filename={`${achievement.title}.xlsx`}
          icon="file-excel"
          packet={{
            achievementIds: [achievement.id],
            ...(isGroupAchievement && listOfGroupCompletionIds?.length
              ? { groupCompletionIds: listOfGroupCompletionIds }
              : {}),
            ...(!isGroupAchievement && listOfUserIds?.length
              ? { userIds: listOfUserIds }
              : {})
          }}
          text={messages.tasksExportTasksData}
          url="/admin/achievements/excel-export"
        />

        {isGroupAchievement ? (
          <AchievementGroupOfUsersRemove updateGroups={updateUsers} />
        ) : (
          <AchievementCompletionsRemoveAll updateUsers={updateUsers} />
        )}
      </MoreOptions>
    </div>
  );
};

export default AchievementUsersHeader;
